import { render, staticRenderFns } from "./WordPressIcon.vue?vue&type=template&id=30f321d3&scoped=true"
import script from "./WordPressIcon.vue?vue&type=script&lang=js"
export * from "./WordPressIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f321d3",
  null
  
)

export default component.exports